import { createAsyncActionConstants } from 'utilities/util';

export const TYPES = {
	FETCH_CUSTOMER_TOGGLES_DATA: createAsyncActionConstants(
		'FETCH_CUSTOMER_TOGGLES_DATA',
	),
};
